"use client";
import { StaticImageData } from "next/image";
import {
  MotionBox,
  MotionBoxProps,
  MotionStack,
  MotionStackProps,
  MotionTypography,
  MotionTypographyProps,
} from "../motion-components";
import { MaterialImage, MaterialImageProps } from "../material-components";
import { alpha, Box, BoxProps } from "@mui/material";
import Link, { LinkProps } from "@cc/link";

export interface InfoSlidesProps {
  img: StaticImageData | string;
  ImageProps?: Partial<MaterialImageProps>;
  title?: string;
  description: string;
  CardWrapperProps?: MotionStackProps;
  ContentWrapperProps?: MotionStackProps;
  TagProps?: MotionBoxProps;
  DescriptionTypographyProps?: MotionTypographyProps;
  date?: string;
  DateTypographyProps?: MotionTypographyProps;
  href: LinkProps["href"];
  maxImageWrapperWidth?: BoxProps["height"];
}

const InfoSlides = (props: InfoSlidesProps) => {
  const {
    img,
    ImageProps,
    title,
    CardWrapperProps,
    ContentWrapperProps,
    TagProps,
    description,
    DescriptionTypographyProps,
    date,
    DateTypographyProps,
    href,
    maxImageWrapperWidth,
  } = props;
  return (
    <Box
      style={{
        textDecoration: "none",
      }}
      {...(href && { href, component: Link })}
    >
      <MotionStack
        direction={"row"}
        columnGap={2}
        alignItems={"stretch"}
        {...CardWrapperProps}
      >
        <Box
          width={1}
          maxWidth={maxImageWrapperWidth}
          maxHeight={418.66}
          position={"relative"}
        >
          <MaterialImage
            src={img}
            alt={title || "img"}
            width={120}
            height={120}
            {...ImageProps}
          />
        </Box>
        <MotionStack
          rowGap={2}
          alignItems={"flex-start"}
          justifyContent={"space-between"}
          {...ContentWrapperProps}
        >
          {title && (
            <MotionBox
              bgcolor={alpha("#fff", 0.2)}
              p={"6px 16px"}
              fontSize={"14px"}
              {...TagProps}
            >
              {title}
            </MotionBox>
          )}
          <MotionTypography
            className="description"
            variant="body1"
            {...DescriptionTypographyProps}
          >
            {description}
          </MotionTypography>
          {date && (
            <MotionTypography variant={"body2"} {...DateTypographyProps}>
              {date}
            </MotionTypography>
          )}
        </MotionStack>
      </MotionStack>
    </Box>
  );
};
export default InfoSlides;
